import { getPath } from '@/router/common'

const baseUrl = {
  title: '回单收到',
  path: 'SignBack'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'SignBack',
    component: () => import(/* webpackChunkName: "SignBack" */ '@/views/receiptManagement/signBack/index.vue'),
    meta: {
      title: '回单收到'
    }
  }
]
